import { bubbleSortManipulations } from "./bubbleSortManipulations";
import { selectionSortManipulations } from "./selectionSortManipulations";
import { insertionSortManipulations } from "./insertionSortManipulations";
import { mergeSortManipulations } from "./mergeSortManipulations";
import { quickSortManipulations } from "./quickSortManipulations";
import { heapSortManipulations } from "./heapSortManipulations";
import { shellSortManipulations } from "./shellSortManipulations";
import { radixSortManipulations } from "./radixSortManipulations";

export default {
	bubbleSortManipulations,
	selectionSortManipulations,
	insertionSortManipulations,
	mergeSortManipulations,
	quickSortManipulations,
	heapSortManipulations,
	shellSortManipulations,
	radixSortManipulations,
};
